import { jsonRpcProvider } from '@wagmi/core/providers/jsonRpc';
import { publicProvider } from '@wagmi/core/providers/public';
import { rpcUrls } from './rpc-urls.js';
export var allProviders = [
    // jsonRpcProvider({
    //   priority: 0,
    //   rpc: (chain) => {
    //     if (chain.id !== 1) return null
    //     return {
    //       http: `https://api.securerpc.com/v1`,
    //       webSocket: `wss://api.securerpc.com/v1`,
    //     }
    //   },
    // }),
    // alchemyProvider({ apiKey: alchemyId, priority: 1 }),
    // publicProvider({ priority: 2 }),
    // jsonRpcProvider({
    //   priority: 0,
    //   rpc: (chain) => {
    //     if (chain.id !== 1) return null
    //     return {
    //       http: `https://api.securerpc.com/v1`,
    //       webSocket: `wss://api.securerpc.com/v1`,
    //     }
    //   },
    // }),
    jsonRpcProvider({
        rpc: function (chain) {
            // we can add others here, but for now we only support drpc
            if (!rpcUrls[chain.id]) {
                return null;
            }
            return {
                http: rpcUrls[chain.id][0],
            };
        },
    }),
    publicProvider(),
    // infuraProvider({ infuraId }),
];
//# sourceMappingURL=providers.js.map